import { tokens, Dropdown, Option } from "@fluentui/react-components";
import React from "react";
import { useEditorStyles } from "../Styles/Editor";

type ArticleDropdownProps = {
    setVatCode: (vat: number) => void;
    currentVAT: number;
    disabled?: boolean
};

export const getVATTypeSelectionString = (s: number): string => {
    switch (s) {
        case 0: return "0%";
        case 6: return "6%";
        case 12: return "12%";
        case 21: return "21%";
    }
    return s.toString() + "%";
};
const getVATTypeSelectionKey = (s: number): string => {
    switch (s) {
        case 0: return "0";
        case 6: return "6";
        case 12: return "12";
        case 21: return "21";
    }
    return s.toString();
};

export const VATDropdown: React.FC<ArticleDropdownProps> = ({ setVatCode, currentVAT, disabled }) => {
    const styles = useEditorStyles();
    return <Dropdown
        style={disabled ? {
            color: tokens.colorNeutralForeground1, // text color 
            WebkitTextFillColor: tokens.colorNeutralForeground1, // required for Chrome
        } : {}}
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        className={styles.fluid}
        onOptionSelect={(event, data) => {
            setVatCode(data.optionValue === undefined ? 21 : parseInt(data.optionValue));
        }}
        value={getVATTypeSelectionString(currentVAT)}
        selectedOptions={[getVATTypeSelectionKey(currentVAT)]}
        disabled={disabled}
    >
        <Option key="21" value="21">21%</Option>
        <Option key="12" value="12">12%</Option>
        <Option key="6" value="6">6%</Option>
        <Option key="0" value="0">0%</Option>
    </Dropdown>;
};